import { createContext, useContext, useState, type ReactNode } from "react";

interface CreateTransactionSheetContextValue {
  isOpen: boolean;
  openSheet: () => void;
  closeSheet: () => void;
}

const CreateTransactionSheetContext = createContext<CreateTransactionSheetContextValue | null>(null);

export function CreateTransactionSheetProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <CreateTransactionSheetContext.Provider
      value={{
        isOpen,
        openSheet: () => setIsOpen(true),
        closeSheet: () => setIsOpen(false),
      }}
    >
      {children}
    </CreateTransactionSheetContext.Provider>
  );
}

export function useCreateTransactionSheet() {
  const context = useContext(CreateTransactionSheetContext);
  if (!context) {
    throw new Error("useCreateTransactionSheet must be used within CreateTransactionSheetProvider");
  }
  return context;
}
